export enum ContractAgreementTypeOptions {
  YES = '336df053-f701-41b0-9cd3-975967fbdbad',
  NO = '85d96e0d-a7e8-488e-aa00-5000c0f242ee',
  UNSIGNED = '7a9c6408-ecb0-4a5c-9850-dcb2ffab0b8d'
}
